const TransactionStatus={
	PENDING: 0,
	CONFIRMED: 1,
	REJECTED: 2,
	INVALID: 3,
	CANCELLED: 4,
	RESCINDED: 5,
	EDITED: 9,
	INHERITED_ERROR: 15,
	REQUESTED_EDIT: 17,
}
export  default TransactionStatus